<mat-card class="services-card" style="width: 100%;">
  <mat-card-header>
    <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
      <div class="left">
        <mat-card-title>Healthcare Services</mat-card-title>
        <mat-card-subtitle>
          Define, review, and maintain the services your organization offers.
        </mat-card-subtitle>
      </div>
      <div class="right gap-10 g-just-flex" style="flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end;">
        @if (canExport$ | async) {
        <button mat-stroked-button extended class="secondary-button" (click)="refresh()" [disabled]="isRefreshing">
          <mat-icon fontIcon="refresh"></mat-icon>
          <span>{{ isRefreshing ? 'Refreshing…' : 'Refresh' }}</span>
        </button>
        }
        @if (canAdd$ | async) {
        <button mat-flat-button color="primary" (click)="openCreateDialog()">
          <mat-icon fontIcon="add"></mat-icon>
          <span>Add Service</span>
        </button>
        }
      </div>
    </div>
  </mat-card-header>

  <mat-card-content class="my-12">
    <mat-divider></mat-divider>

    <app-table-header [searchBoxTitle]="'Search services by name...'" (searchCriteriaChanged)="onSearch($event)">
    </app-table-header>

    @if (loading$ | async) {
    <div class="loading-state" style="padding: 40px; text-align: center;">
      <mat-progress-spinner diameter="48" mode="indeterminate" style="margin: 0 auto;"></mat-progress-spinner>
      <p>Loading healthcare services…</p>
    </div>
    } @else {
    @if (dataSource.data.length) {
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" class="services-table" style="width: 100%;">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let row">
            <div class="service-name">
              <span class="service-name__title">{{ row.name }}</span>
              @if (row.rawResource.type?.length) {
              <span class="chip">
                <strong>{{ row.rawResource.type[0].text || row.rawResource.type[0].coding?.[0]?.display }}</strong>
              </span>
              }
            </div>
            @if (row.rawResource.comment) {
            <div class="service-name__note">{{ row.rawResource.comment }}</div>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            <span [appChips]="row.status === 'active' ? 'Active' : 'Inactive'" [fontSize]="'14px'"></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef>Category</th>
          <td mat-cell *matCellDef="let row">
            {{ row.category }}
          </td>
        </ng-container>

        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef>Default Location</th>
          <td mat-cell *matCellDef="let row">
            {{ row.location }}
          </td>
        </ng-container>

        <ng-container matColumnDef="updated">
          <th mat-header-cell *matHeaderCellDef>Updated</th>
          <td mat-cell *matCellDef="let row">
            <div class="top">
              {{ row.lastUpdated | date : 'mediumDate' : undefined : 'en-US' }}
            </div>
            <div class="bottom subtitle-text-color-2">
              {{ row.lastUpdated | date : 'shortTime' : undefined : 'en-US' }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button [matMenuTriggerFor]="rowMenu" aria-label="Service actions">
              <mat-icon fontIcon="more_vert"></mat-icon>
            </button>
            <mat-menu #rowMenu="matMenu">
              <button mat-menu-item (click)="openEditDialog(row.rawResource)">
                <mat-icon fontIcon="edit"></mat-icon>
                <span>Edit</span>
              </button>
              @if (row.status === 'inactive') {
              <button mat-menu-item (click)="toggleActive(row.rawResource, true)">
                <mat-icon fontIcon="toggle_on"></mat-icon>
                <span>Activate</span>
              </button>
              } @else {
              <button mat-menu-item (click)="toggleActive(row.rawResource, false)">
                <mat-icon fontIcon="toggle_off"></mat-icon>
                <span>Deactivate</span>
              </button>
              }
              <button mat-menu-item (click)="delete(row.rawResource)">
                <mat-icon fontIcon="delete"></mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" [attr.data-service-id]="row.id"></tr>
      </table>
    </div>

    <mat-paginator [length]="(total$ | async) ?? 0" [pageSize]="25" [hidePageSize]="true" (page)="onPageChange($event)">
    </mat-paginator>
    } @else {
    <div class="empty-state" style="padding: 40px; text-align: center;">
      <mat-icon fontIcon="stethoscope" style="font-size: 48px; height: 48px; width: 48px;"></mat-icon>
      <p>No healthcare services found. Add your first service or adjust your search.</p>
    </div>
    }
    }
  </mat-card-content>
</mat-card>